import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWarehouseCategoryList as getWarehouseCategoryListApi,
	getWarehouseCategory as getWarehouseCategoryApi,
	addNewWarehouseCategory as addNewWarehouseCategoryApi,
	updateWarehouseCategory as updateWarehouseCategoryApi,
	deleteWarehouseCategory as deleteWarehouseCategoryApi,
	checkWarehouseCategoryExists as checkWarehouseCategoryExistsApi
} from '../../helpers/warehouse/backend_helper';

export const getWarehouseCategoryList = createAsyncThunk('warehouse_categories/getWarehouseCategoryList', async (params) => {
	try {
		const response = getWarehouseCategoryListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWarehouseCategory = createAsyncThunk('warehouse_categories/getWarehouseCategory', async warehouse_category_id => {
	try {
		const response = getWarehouseCategoryApi(warehouse_category_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewWarehouseCategory = createAsyncThunk('warehouse_categories/addNewWarehouseCategory', async warehouse_category => {
	try {
		const response = addNewWarehouseCategoryApi(warehouse_category);
		toast.success('Categoría agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateWarehouseCategory = createAsyncThunk('warehouse_categories/updateWarehouseCategory', async (warehouse_category) => {
		try {
			console.log('comienza??')
			const response = updateWarehouseCategoryApi(warehouse_category);
			toast.success('Categoría actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar la categoría.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteWarehouseCategory = createAsyncThunk('warehouse_categories/deleteWarehouseCategory', async warehouse_category => {
	try {
		const response = await deleteWarehouseCategoryApi(warehouse_category);
		toast.success('Categoría eliminado exitosamente.', { autoClose: 3000 });
		return { warehouse_category, ...response };
	} catch (error) {
		toast.error('Error al eliminar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
});


export const checkWarehouseCategoryExists = createAsyncThunk('warehouse_categories/checkWarehouseCategoryExists', async name => {
	try {
		const response = await checkWarehouseCategoryExistsApi(name);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});